// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--8f184";
export var footerBottom = "footer-module--footer-bottom--aef34";
export var footerContent = "footer-module--footer-content--c2f1f";
export var footerLeft = "footer-module--footer-left--4936a";
export var footerLinks = "footer-module--footer-links--40ebe";
export var footerMiddle = "footer-module--footer-middle--362b1";
export var footerRight = "footer-module--footer-right--bf429";
export var footerRss = "footer-module--footer-rss--04b4d";
export var footerRssLinks = "footer-module--footer-rss-links--04e5e";
export var footerRssTitle = "footer-module--footer-rss-title--bab83";
export var footerSocial = "footer-module--footer-social--ebcb8";
export var goToHead = "footer-module--go-to-head--e45e5";